import { useCallback, useState } from 'react'

import { Popup } from '@/components/popup/popup'
import { Typography } from '@/components/typography/typography'
import { useAppConfigStore } from '@/stores/app-store-config/appConfigStore'
import { translate } from '@/utils/translator'

import { useLocations } from './useLocations'

export const useCantBookOnline = () => {
	const [isOpen, setIsOpen] = useState(false)
	const [hotelCode, setHotelCode] = useState<string>()
	const { data } = useLocations()
	const reservationMail = useAppConfigStore.use.reservationMail()

	const cantBeBooked = useCallback(
		(hotelCode: string) => {
			const temporaryNotBookable = Boolean(
				data?.find((h) => h.hotelCode === hotelCode)?.temporaryNotBookable
			)

			if (!temporaryNotBookable) return false

			setIsOpen(true)
			setHotelCode(hotelCode)
			return Boolean(temporaryNotBookable)
		},
		[data]
	)

	const PopupComp = () => {
		const hotelElement = document.querySelector(
			`[data-hotelCode="${hotelCode}"]`
		) as HTMLElement | null

		return (
			<Popup
				element={hotelElement}
				open={isOpen}
				onClose={() => setIsOpen(false)}
				closeOnClickOutside
				title={translate('location-cant-be-booked-title')}
				content={
					<Typography element="p" style="p">
						{translate('location-cant-be-booked-text', [reservationMail])}
					</Typography>
				}
			/>
		)
	}

	return { cantBeBooked, CantBeBookedPopup: PopupComp }
}
